import { APPS } from "../utils/constants";
import MobileApp from "./MobileApp";

export default function Projects ({ darkMode }) {

    return (
        <div className="m-4 my-10 flex flex-col" id="projects">
            <h2 className='font-bold'>My App Projects</h2>
            <div className="flex flex-wrap justify-around">
                {APPS.map(app => <MobileApp darkMode={darkMode} appInfo={app} key={app.id}/>)}
            </div>
        </div>
    )
}